import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { HEAD_MESH_DIMENSIONS } from '../../../../utils';
import SuspenseBoundary from '../../r3f-components/components/boundaries/EntitySuspense';
import FaceLandmarkHotspots from './FaceLandmarkHotspots';
import FaceMesh from './FaceMesh';
import HeadMesh from './HeadMesh';
const FaceTrackingPlaceholder = () => {
    const [headMeshRendered, setHeadMeshRendered] = useState(false);
    return (_jsx(SuspenseBoundary, { scale: HEAD_MESH_DIMENSIONS, position: [0, 0, 0], rotation: [0, 0, 0], renderOrder: 1, children: _jsxs(_Fragment, { children: [_jsx(FaceMesh, {}), _jsx(HeadMesh, { ref: (_ref) => setHeadMeshRendered(true) }), headMeshRendered && _jsx(FaceLandmarkHotspots, {})] }) }));
};
export default FaceTrackingPlaceholder;
